import { lazy } from 'react';

export const lazyWithRetry = (
  componentImport: () => Promise<{ default: React.ComponentType<any> }>
) =>
  lazy(async () => {
    const pageHasAlreadyBeenForceRefreshed =
      localStorage.getItem('page-has-been-force-refreshed') === 'true';
    const currentPath =
      window.location.pathname + window.location.search + window.location.hash;
    sessionStorage.setItem('last-path', currentPath);
    try {
      const component = await componentImport();
      localStorage.removeItem('page-has-been-force-refreshed');
      return component;
    } catch (error) {
      console.error('Error loading component:', error);

      if (!pageHasAlreadyBeenForceRefreshed) {
        // Assuming that the user is not on the latest version of the application.
        // Let's refresh the page immediately.
        localStorage.setItem('page-has-been-force-refreshed', 'true');

        // Try to preserve the current URL
        const currentPath =
          window.location.pathname +
          window.location.search +
          window.location.hash;
        sessionStorage.setItem('last-path', currentPath);

        // Use replace instead of reload to avoid browser history issues
        window.location.replace(currentPath);

        return new Promise(() => {});
      }
      console.error('lazy loading of component failed', error);

      // The page has already been reloaded
      // Assuming that user is already using the latest version of the application.
      // Let's let the application crash and raise the error.
      throw error;
    }
  });
